import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import NotFound from '../../share/components/ErrorPage/NotFoundPage';
import environmentHelper from 'src/share/utils/environmentHelper';
import AuthRoute from './auth/AuthRoute';
import { useRoutes } from 'src/modules/Routing/hooks/routes/useRoutes';
import { useAnalytics } from 'src/share/hooks/useAnalytics';

const Router = () => {
  const [routes] = useRoutes();
  useAnalytics(environmentHelper.getGoogleAnalyticsTrackId())
  return (
    <Switch>
      {
        routes.map((route) => {
          return (
            <Route exact={true} key={route.key} path={route.path} >
              {
                (match) => <AuthRoute match={match} linkedRoute={route} />
              }
            </Route>
          )
        })
      }
      <Route component={NotFound} />
    </Switch>
  )
}
export default React.memo(Router)


// WEBPACK FOOTER //
// ./src/modules/Routing/Router.tsx